import React, { ReactNode, useState } from 'react'
import { FaChevronDown, FaChevronRight } from 'react-icons/fa'
import styles from './styles.module.scss'

interface Props {
    title: string
    /** Small grey summary shown next to the title (counts etc.). */
    meta?: ReactNode
    /** Closed unless told otherwise — the optics page opens with everything collapsed. */
    defaultOpen?: boolean
    /** Card style for the wrapper: outer group, nested subsection, or a standalone panel (filters). */
    variant?: 'group' | 'sub' | 'panel'
    /** Heading level: the outer group uses h3, subsections h4. */
    level?: 'h3' | 'h4'
    children: ReactNode
}

/**
 * Whole-row toggle card. Children are only mounted while open, so anything
 * that fetches on mount (e.g. the lender table) is loaded lazily on expand.
 */
export const CollapsibleSection = ({
    title,
    meta,
    defaultOpen = false,
    variant = 'sub',
    level = 'h4',
    children,
}: Props) => {
    const [open, setOpen] = useState(defaultOpen)
    const Heading = level
    return (
        <div className={WRAPPER_CLASS[variant]}>
            <button
                type="button"
                className={styles.collapseHeader}
                onClick={() => setOpen((o) => !o)}
                aria-expanded={open}
            >
                {open ? <FaChevronDown aria-hidden="true" /> : <FaChevronRight aria-hidden="true" />}
                <Heading>{title}</Heading>
                {meta != null && meta !== '' && <span className={styles.collapseMeta}>{meta}</span>}
                <span className={styles.collapseHint}>{open ? 'Hide' : 'Show'}</span>
            </button>
            {open && <div className={styles.collapseBody}>{children}</div>}
        </div>
    )
}

const WRAPPER_CLASS: Record<NonNullable<Props['variant']>, string> = {
    group: styles.purgeGroupCard,
    sub: styles.purgeSubCard,
    panel: styles.filterPanel,
}
